import * as React from 'react';

import { type CourseFrameContextType, NavSingleItemDisplayV2, useCourseFrameContext } from '@coursera-web/course-frame';

import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

import NavPeerReviewItemDisplay from 'bundles/learner-progress/components/item/nav/private/NavPeerReviewItemDisplay';
import NavSingleItemDisplay from 'bundles/learner-progress/components/item/nav/private/NavSingleItemDisplay';
import type { Item as ItemType } from 'bundles/learner-progress/types/Item';
import { getIsAssignmentPartForSplitPeer } from 'bundles/learner-progress/utils/Item';
import withComputedItem from 'bundles/learner-progress/utils/withComputedItem';

type PropsFromCaller = {
  itemMetadata?: ItemMetadata;
  highlighted?: boolean;
  trackingName?: string;
  openInNewWindow?: boolean;
  iconSize?: number;
};

type PropsFromWithComputedItem = {
  computedItem: ItemType;
};

type PropsFromWrapper = Pick<CourseFrameContextType, 'isCourseFrameEnabled'>;

// Props for the original NavItem class component
type NavItemInnerProps = PropsFromCaller & PropsFromWithComputedItem & PropsFromWrapper;

// Individual item shown in the navigation on item pages
export class NavItemInner extends React.Component<NavItemInnerProps> {
  render() {
    const { computedItem, highlighted, trackingName, openInNewWindow, iconSize, isCourseFrameEnabled } = this.props;

    if (getIsAssignmentPartForSplitPeer(computedItem)) {
      return (
        <NavPeerReviewItemDisplay
          computedItem={computedItem}
          highlighted={highlighted}
          trackingName={trackingName}
          openInNewWindow={openInNewWindow}
          iconSize={iconSize}
        />
      );
    }

    return (
      <div>
        {isCourseFrameEnabled ? (
          <NavSingleItemDisplayV2 computedItem={computedItem} highlighted={highlighted} />
        ) : (
          <NavSingleItemDisplay
            computedItem={computedItem}
            highlighted={highlighted}
            trackingName={trackingName}
            openInNewWindow={openInNewWindow}
            iconSize={iconSize}
          />
        )}
      </div>
    );
  }
}

// Wrapper component to call hook and pass isCourseFrameEnabled to the class component
type NavItemWrapperProps = PropsFromCaller & PropsFromWithComputedItem;

const NavItemWrapper = (props: NavItemWrapperProps) => {
  const { isCourseFrameEnabled } = useCourseFrameContext();

  return <NavItemInner {...props} isCourseFrameEnabled={isCourseFrameEnabled} />;
};

export default withComputedItem(NavItemWrapper);
